// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Z5-VC","icon":"index_icon_Rl-pb"};